import React, { ReactNode } from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { colors, layout, shadows } from "@/constants";

/**
 * Props for the Card component
 */
interface CardProps {
  /** Child components to render inside the card */
  children: ReactNode;
  /** Optional custom styles */
  style?: ViewStyle;
  /** Optional background color override */
  backgroundColor?: string;
}

/**
 * Base card component with consistent styling
 * Provides elevation, border radius, and padding
 *
 * @param props - The component props
 * @returns A styled card container
 */
export default function Card({ children, style, backgroundColor }: CardProps) {
  return (
    <View style={[styles.card, backgroundColor && { backgroundColor }, style]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.aiContainer,
    borderRadius: layout.borderRadius.medium,
    padding: layout.space.lg,
    ...shadows.subtle
  }
});
